/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { connect } from 'react-redux';

function ServicesSelector(props: any) {
  const options = props.items.map((item: any) => ({
    key: item.id,
    value: item.id,
    text: `${item.name}`
  }));
  return (
    <Dropdown
      multiple={props.multiple}
      selection
      name={props.name}
      value={props.value}
      onChange={props.onChange}
      options={options}
    />
  );
}

export default connect(
  (state: any) => ({ items: state.services.myServices }),
  () => ({})
)(ServicesSelector);

ServicesSelector.defaultProps = {
  multiple: true
};
